<template>
  <div>
    <create-edit-action-modal
      v-if="showCreateEditActionModal"
      :registryId="registryId"
      :nextNumberAction="nextNumberAction"
      :actionId="actionIdSelected"
      @closeModal="closeModal"
      @deleteAction="deleteAction"
    />
    <done-action-modal
      v-if="showDoneActionModal"
      :registryId="registryId"
      :actionId="actionIdSelected"
      :doneAction="isDoneAction"
      @closeModal="closeModal"
      @unDoneAction="unDoneAction"
    />
    <un-done-action-modal
      v-if="showUnDoneActionModal"
      :registryId="registryId"
      :actionId="actionIdSelected"
      @closeModal="closeModal"
    />
    <delete-action-modal
      v-if="showDeleteActionModal"
      :registryId="registryId"
      :actionId="actionIdSelected"
      @closeModal="closeModal"
    />
    <div class="row border mx-2 pt-3">
      <div class="col-12 mb-2">
        <h5>
          Ações a serem implementadas:
          <button
            v-if="canEditRegistry"
            class="btn btn-outline-theme d-print-none"
            title="Cadastrar Ação"
            @click="createEditAction()"
          >
            Cadastrar Ação
          </button>
        </h5>
      </div>
      <div class="col-12">
        <div v-if="actions.length > 0" class="table-responsive">
          <table class="table mb-1">
            <thead>
              <tr>
                <th>AÇÃO</th>
                <th>STATUS</th>
                <th>RESPONSÁVEL</th>
                <th>PRAZO</th>
                <th class="text-center d-print-none">OPERAÇÕES</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="action in actions"
                :key="action.id"
                :title="`Criado por: ${createdUpdatedUser(
                  action.usuarioCriacao,
                  action.dataCriacao,
                )} | Modificador por: ${createdUpdatedUser(
                  action.usuarioModificacao,
                  action.dataModificacao,
                )}`"
              >
                <td>
                  {{ action.numero }}.
                  <span class="pre-line">{{ action.descricao }}</span>
                </td>
                <td v-html="statusAction(action.status)" />
                <td>{{ action.responsavel }}</td>
                <td>{{ dateSqlToDateBR(action.prazo) }}</td>
                <td class="text-center d-print-none">
                  <button
                    v-if="canEditRegistry"
                    class="btn btn-sm btn-outline-warning"
                    title="Editar"
                    @click="createEditAction(action.id)"
                  >
                    <i class="far fa-edit"></i>
                  </button>
                  <span v-if="action.status === 'Em Aberto'"> | </span>
                  <button
                    v-if="action.status === 'Em Aberto'"
                    class="btn btn-sm btn-outline-theme"
                    title="Concluir"
                    @click="doneAction(action.id, true)"
                  >
                    <i class="far fa-check-circle"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else>Nenhuma ação cadastrada.</p>
      </div>
    </div>
    <div class="row border mx-2 pt-3">
      <div class="col-12 mb-2">
        <h5>Verificação da implementação das ações:</h5>
      </div>
      <div class="col-12">
        <div v-if="actions.length > 0" class="table-responsive">
          <table class="table mb-1">
            <thead>
              <tr>
                <th>AÇÃO</th>
                <th class="text-center">IMPLEMENTAÇÃO</th>
                <th>REGISTRO DOS RESULTADOS (EVIDÊNCIA)</th>
                <th class="text-center d-print-none">OPERAÇÕES</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="action in actions" :key="action.id">
                <td :title="action.descricao">{{ action.numero }}.</td>
                <td
                  v-if="action.status === 'Fechado'"
                  class="text-center"
                  :class="{
                    'text-theme': action.implementada === 'Sim',
                    'text-danger': action.implementada !== 'Sim',
                  }"
                >
                  {{ action.implementada }}
                </td>
                <td v-else class="text-center">-</td>
                <td v-if="action.status === 'Fechado'">
                  <span class="pre-line">{{ action.resultado }}</span>
                </td>
                <td v-else>-</td>
                <td
                  v-if="action.status === 'Fechado' && canEditRegistry"
                  class="text-center d-print-none"
                >
                  <button
                    class="btn btn-sm btn-outline-warning"
                    onclick=""
                    title="Editar"
                    @click="doneAction(action.id, false)"
                  >
                    <i class="far fa-edit"></i>
                  </button>
                </td>
                <td v-else class="text-center d-print-none">-</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p v-else>Nenhuma ação cadastrada.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { createdUpdatedUser, statusAction } from '@/utils/strings'
import { dateSqlToDateBR } from '@/utils/date'
import CreateEditActionModal from '@/components/actions/CreateEditActionModal.vue'
import DoneActionModal from '@/components/actions/DoneActionModal.vue'
import UnDoneActionModal from '@/components/actions/UnDoneActionModal.vue'
import DeleteActionModal from '@/components/actions/DeleteActionModal.vue'

export default {
  name: 'ListActions',

  components: {
    CreateEditActionModal,
    DoneActionModal,
    UnDoneActionModal,
    DeleteActionModal,
  },

  props: {
    registryId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      actions: [],
      showCreateEditActionModal: false,
      showDoneActionModal: false,
      showUnDoneActionModal: false,
      showDeleteActionModal: false,
      nextNumberAction: 1,
      actionIdSelected: null,
      isDoneAction: false,
      createdUpdatedUser,
      statusAction,
      dateSqlToDateBR,
    }
  },

  computed: {
    canEditRegistry() {
      return this.$store.getters.canEditRegistry
    },
  },

  methods: {
    async getActions() {
      try {
        this.actions = await this.$store.dispatch('getActions', this.registryId)
      } catch (error) {
        if (error && error.message) {
          this.$snotify.warning(error.message, 'Atenção!')
        } else {
          this.$snotify.error(
            'Não foi possível se conectar ao servidor.',
            'Erro!',
          )
        }
      }
    },

    createEditAction(actionId) {
      this.actionIdSelected = actionId || null
      const lastAction = [...this.actions].pop()
      if (lastAction) {
        this.nextNumberAction = Number(lastAction.numero) + 1
      } else {
        this.nextNumberAction = 1
      }
      this.showCreateEditActionModal = true
    },

    doneAction(actionId, done) {
      this.actionIdSelected = actionId
      this.isDoneAction = done
      this.showDoneActionModal = true
    },

    unDoneAction() {
      this.showDoneActionModal = false
      this.showUnDoneActionModal = true
    },

    deleteAction() {
      this.showCreateEditActionModal = false
      this.showDeleteActionModal = true
    },

    closeModal(reloadData) {
      if (reloadData) {
        this.$store.dispatch('setReloadDetailsRegistry', true)
        this.getActions()
      }
      this.showCreateEditActionModal = false
      this.showDoneActionModal = false
      this.showUnDoneActionModal = false
      this.showDeleteActionModal = false
    },
  },

  mounted() {
    this.getActions()
  },
}
</script>
